import {create} from "zustand";

export interface IUnifyProfileStore {
    unifyProfile: any;
    setUnifyProfile: (unifyProfile:IUnifyProfile) => void;
}

export interface IUnifyProfile {
  unifyProfile?: any
}
  
export const useUnifyProfileStore = create<IUnifyProfileStore>((set) => ({
    unifyProfile: {},
    setUnifyProfile: (unifyProfile) => set(() => ({ unifyProfile })),
 }));
